export const selectAllQuestions = (state) => state.questions.questions; // Selector to get meals data
export const selectLoading = (state) => state.questions.loading; // Selector to get loading state
export const selectTotal = (state) => state.questions.total; // Selector for total pages
export const selectError = (state) => state.questions.error; // Selector for error state
export const selectCurrentPage = (state) => state.questions.page;
export const selectLimit = (state) => state.questions.limit;
